export const walletTableHeaders = [
  "Date",
  "Company Name",
  "Company Type",
  "Status",
];

export const walletTableKeys = [
  "date",
  "company_name",
  "company_type",
  "status",
];

export const walletData = () => {
  const data = new Array(10).fill(null).map((_, index) => ({
    id: index + 1,
    date: { value: `25-Nov-${index + 2}`, type: "string" },
    company_name: { value: "Matino Chem", type: "string" },
    company_type: { value: "Distributor", type: "string" },
    status: {
      value:
        index % 2 ? (
          <span className="text-green-500">Completed</span>
        ) : index % 3 ? (
          <span className="text-yellow-600 rounded-md">Pending</span>
        ) : (
          <span className="text-blue-500">In review</span>
        ),
      type: "string",
    },
  }));
  return data;
};
